import {
    Button,
    DateInput,
    FormWithRedirect,
    Identifier,
    SaveButton,
    TextInput,
    useNotify,
    useRefresh
} from "react-admin";
import {useToggler} from "../../../shared/hooks/useToggler";
import {useState} from "react";
import {clientNoJson} from "../../../dataProvider";
import {CircularProgress, Dialog, DialogActions, DialogContent} from "@material-ui/core";
import {dateFormatter} from "../../../shared/utils";
import SendIcon from '@material-ui/icons/Send';
import IconCancel from "@material-ui/icons/Cancel";

export const SendInvoiceButton = ({ ids }: { ids?: Identifier[] }) => {
    const { value: dialogOpen, setFalse: closeDialog, setTrue: openDialog } = useToggler();
    const refresh = useRefresh();
    const notify = useNotify();
    const [loading, setLoading] = useState<boolean>(false);
  
  
    const handleSubmit = async (values: any) => {
  
      setLoading(true);
      let res = null;
  
      try {
        res = await clientNoJson(`api/payment_schedule_status/reminder_emails/`, {
          method: "POST",
          data: {
            ids: ids,
            ...values
          },
          responseType: "arraybuffer",
        });
      } catch (err) {
        notify("ra.message.error", "error");
        setLoading(false);
        return;
      }
      setLoading(false);
      notify("Solleciti generati", "success");
      try {
        refresh();
        closeDialog();
      }
      catch (e) {
  
      }
  
    };
  
    return (
      <>
        <Button
          size="small"
          color="primary"
          label="Genera sollecito ed invia email"
          onClick={() => openDialog()}
        >
          {loading ? <CircularProgress size={18} thickness={2} /> : <><SendIcon /></>}
        </Button>
        <Dialog
          onClick={(e) => e.stopPropagation()}
          open={dialogOpen} maxWidth="sm" fullWidth>
          <FormWithRedirect
            save={handleSubmit}
            render={({ handleSubmitWithRedirect, saving }) => (
              <>
                <DialogContent>
                  <DateInput
                    initialValue={dateFormatter(new Date())}
                    source={"date"}
                    label={"Data sollecito"}
                    canEdit={true}
                    fullWidth
                  />
                  <TextInput
                    source={"email_text"}
                    label={"Data sollecito"}
                    canEdit={true}
                    multiline
                    defaultValue={
                      "Gentile cliente,\nriportiamo in allegato il Suo estratto conto relativo al ns avere alla data odierna.\nLa preghiamo pertanto di regolarizzare al più presto la sua posizione contabile, ricordando che il pagamento può essere effettuato a mezzo bonifico bancario, utilizzando i riferimenti presenti nella fattura elettronica.\n\nNel caso in cui il bonifico sia stato già disposto, potrà ritenere nulla la presente richiesta.\nIn attesa di suo gradito riscontro e restando a disposizione per eventuali delucidazioni,\nci è gradita l’occasione per porgere distinti saluti."
                    }
                    rows={10}
                    fullWidth
                  />
  
                </DialogContent>
                <DialogActions>
                  <Button label="ra.action.cancel" onClick={closeDialog}>
                    <IconCancel />
                  </Button>
                  <SaveButton
                    handleSubmitWithRedirect={handleSubmitWithRedirect}
                    saving={saving}
                    disabled={loading}
                  />
                </DialogActions>
              </>
            )}
          />
        </Dialog>
      </>
    );
  };